import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '@api-ui-app/src/app/app.state';
import { EProductAbbridged } from '@gelato-api-ui/core/e-commerce/e-product-abbridged';
import { EProductPublishingErrorCode } from '@gelato-api-ui/core/e-commerce/e-product-publishing-errors.enum';
import * as actions from '@api-ui-app/src/app/e-commerce-product-publishing/+state/e-commerce-product-publishing.actions';
import { SplashMessage } from '@api-ui-app/src/app/shared/splash-message/lib/splash-message';
import * as selectors from '@api-ui-app/src/app/e-commerce-product-publishing/+state/e-commerce-product-publishing.selectors';

@Injectable({ providedIn: 'root' })
export class ECommerceProductPublishingNotificationsFacade {
  readonly statuses$ = this.store.select(selectors.getStatuses);

  constructor(private readonly store: Store<AppState>) {}

  showSuccessStatusMessage(product: EProductAbbridged) {
    this.store.dispatch(
      actions.showSuccessStatusMessage({
        productId: product.id,
        productTitle: product.title,
        detailsFlags: product.publishingDetailsFlags,
      }),
    );
  }

  showErrorStatusMessage(
    productId: string,
    productTitle: string,
    errorCode?: EProductPublishingErrorCode,
    errorDetails?: string,
  ) {
    this.store.dispatch(actions.showErrorStatusMessage({ productId, productTitle, errorCode, errorDetails }));
  }

  hideAllStatusMessages() {
    this.store.dispatch(actions.hideAllStatusMessages());
  }

  hideStatusMessage(productId: string) {
    this.store.dispatch(actions.hideStatusMessage({ productId }));
  }

  showInfoNotification(payload: Partial<SplashMessage>) {
    this.store.dispatch(actions.showInfoNotification({ payload }));
  }
}
